/**
 * Poster-Adresse fuer ein Video herleiten (WK-Befund 1, 31.08.2026).
 *
 * Der Upload legt zu jedem Video ein Erstes-Frame-JPEG ab; ausgeliefert wird
 * es unter `/resource/:id/poster` (Backend leitet aufs /img-Shim weiter —
 * klein, WebP, CORS-sauber). Nur fuer unsere eigenen Asset-URLs der Form
 * `…/resource/<uuid>` — Legacy-Quellen (GCS, .online, Cloudinary) haben kein
 * Poster; dort liefert null das bisherige Verhalten (Mesh erst mit Video).
 */
// `(?:\?.*)?`: Renditions-Adressen tragen `?r=web&v=…` (Backend, 02.09.2026) —
// das Poster liegt trotzdem unter der nackten `/resource/<uuid>/poster`.
const RESOURCE_VIDEO_URL = /^(https?:\/\/[^/]+\/resource\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/?(?:\?.*)?$/i;

export function posterUrlFuerVideo(url: string | null | undefined): string | null {
    if (!url) return null;
    const treffer = RESOURCE_VIDEO_URL.exec(url);
    return treffer ? `${treffer[1]}/poster` : null;
}
